/**
 * Clip Room — the room's home (Ben, 2026-10-23): the club's saved reels
 * first (what you come back for), then every match you can cut new clips
 * from. The Reels index merged in from /playlists/ — same list, same
 * actions; the old address redirects here and reel deep links
 * (/playlists/<id>, /playlists/<id>/play) stay where they were.
 */
import { type Session } from '../lib/api'
import WorthALook from '../components/WorthALook'
import Games from './Games'
import Playlists from './Playlists'

export default function ClipRoom({ session }: { session: Session }) {
  return (
    <>
      <h1 className="page-title">Clip Room</h1>
      <p className="page-sub">
        {session.org?.name ?? 'No club selected'} · your reels, and every
        match you can cut new clips from.
      </p>

      <WorthALook limit={8} />

      <section className="dash-section">
        <Playlists embedded />
      </section>

      <section className="dash-section">
        <h2 className="dash-section__title">Cut new clips</h2>
        <Games session={session} room="clip" embedded />
      </section>
    </>
  )
}
